export const linkMapping = {
  campaign: (link) => link.campaign.name,
  channel: (link) => link.marketer_data.channel,
  medium: (link) => link.client_data.Medium,
  source: (link) => link.marketer_data.channel,
  marketer: (link) => link.marketer_data.marketer,
};
